module.exports = "<div class=mui-group-item> <div class=\"mui-group-item-bd mui-group-item-primary\"> <textarea class=mui-textarea placeholder={{placeholder}} rows=3 v-model=value></textarea> <div class=mui-textarea-counter v-show=\"showCounter && max\"><span>{{count}}</span>/{{max}}</div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/m-textarea/index.vue
 ** module id = 169
 ** module chunks = 0
 **/